/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './treatment-delivery-plan.reducer';

export const TreatmentDeliveryPlanDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const treatmentDeliveryPlanEntity = useAppSelector(state => state.treatmentDeliveryPlan.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="treatmentDeliveryPlanDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.treatmentDeliveryPlan.detail.title">TreatmentDeliveryPlan</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.treatmentDeliveryPlan.id">Id</Translate>
            </span>
          </dt>
          <dd>{treatmentDeliveryPlanEntity.id}</dd>
          <dt>
            <span id="startDate">
              <Translate contentKey="tinyMedicRestApp.treatmentDeliveryPlan.startDate">Start Date</Translate>
            </span>
          </dt>
          <dd>{treatmentDeliveryPlanEntity.startDate}</dd>
          <dt>
            <span id="endDate">
              <Translate contentKey="tinyMedicRestApp.treatmentDeliveryPlan.endDate">End Date</Translate>
            </span>
          </dt>
          <dd>{treatmentDeliveryPlanEntity.endDate}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="tinyMedicRestApp.treatmentDeliveryPlan.status">Status</Translate>
            </span>
          </dt>
          <dd>{treatmentDeliveryPlanEntity.status}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.treatmentDeliveryPlan.active">Active</Translate>
            </span>
          </dt>
          <dd>{treatmentDeliveryPlanEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.treatmentDeliveryPlan.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{treatmentDeliveryPlanEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.treatmentDeliveryPlan.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{treatmentDeliveryPlanEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.treatmentDeliveryPlan.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{treatmentDeliveryPlanEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.treatmentDeliveryPlan.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{treatmentDeliveryPlanEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentDeliveryPlan.template">Template</Translate>
          </dt>
          <dd>{treatmentDeliveryPlanEntity.template ? treatmentDeliveryPlanEntity.template.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentDeliveryPlan.patient">Patient</Translate>
          </dt>
          <dd>{treatmentDeliveryPlanEntity.patient ? treatmentDeliveryPlanEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentDeliveryPlan.physician">Physician</Translate>
          </dt>
          <dd>{treatmentDeliveryPlanEntity.physician ? treatmentDeliveryPlanEntity.physician.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/treatment-delivery-plan" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/treatment-delivery-plan/${treatmentDeliveryPlanEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TreatmentDeliveryPlanDetail;
